import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { AlertMessage } from '../models/alerts/alert';
import { ErrorCollection } from '../models/common/errorCollection';

@Injectable()
export class AlertService {
	public alertStatus: BehaviorSubject<AlertMessage> = new BehaviorSubject<AlertMessage>({
		message: null,
		iconClass: ''
	});

	showSuccess(message: string) {
		let alert: AlertMessage = {
			message: message,
			iconClass: 'w3-xlarge fa fa-check-circle w3-text-green'
		};
		this.alertStatus.next(alert);
	}

	showError(message: string) {
		let alert: AlertMessage = {
			message: message,
			iconClass: 'w3-xlarge fa fa-times-circle w3-text-red'
		};
		this.alertStatus.next(alert);
	}

	showWarning(message: string) {
		let alert: AlertMessage = {
			message: message,
			iconClass: 'w3-xlarge fa fa-exclamation-circle w3-text-orange'
		};
		this.alertStatus.next(alert);
	}

	showInfo(message: string) {
		let alert: AlertMessage = {
			message: message,
			iconClass: 'w3-xlarge fa fa-info-circle w3-text-blue'
		};
		this.alertStatus.next(alert);
	}

	displayErrorResult(errorCollection: ErrorCollection) {
		if (errorCollection != undefined && errorCollection['errors'] != undefined) {
			let errorMessage = '';
			errorCollection.errors.forEach(e => {
				errorMessage += `(${e.code}): ${e.message}; `;
			});

			this.showError(errorMessage);
		}
	}

	showGenericError(){
		this.showError('A problem occured while processing your request. Please contact your administrator.');
	}
}



// WEBPACK FOOTER //
// ./src/app/services/alert.service.ts